import type { IServiceMethod } from '@/shared/api';
import { appApi } from '@/shared/api';
import { ticketControlApi } from '@/shared/api/api';
import type {
	ICurrenciesAndCountriesResponse,
	ICurrenciesResponse,
	IFreeTicketModel,
	IGetPlayerStarsTicketsRequest,
	IGetPlayerStarsTicketsResponse,
	IGetPlayerTonTicketsRequest,
	IGetPlayerTonTicketsResponse,
	IPaidTicketModel,
	ITicketByPaymentResponse,
	ITicketCreateIntentResponse,
	ITicketCreateRequest,
	ITicketCreateResponse,
	ITicketStatsModel,
} from './types';

const create: IServiceMethod<ITicketCreateResponse, ITicketCreateRequest> = (body) =>
	ticketControlApi.post<ITicketCreateResponse, ITicketCreateRequest>('api/Tickets/payments', { body }, true);

create.queryKey = 'createPayment';

const createIntent: IServiceMethod<ITicketCreateIntentResponse, ITicketCreateRequest> = (body) =>
	ticketControlApi.post<ITicketCreateIntentResponse, ITicketCreateRequest>('api/Tickets/payments', { body }, true);

createIntent.queryKey = 'createIntent';

const getTicketByPayment: IServiceMethod<ITicketByPaymentResponse, number> = (id) =>
	ticketControlApi.get<ITicketByPaymentResponse>(`api/Tickets/payment/${id}/ticket`, {}, true);

getTicketByPayment.queryKey = 'getTicketByPayment';

const getCurrencies: IServiceMethod<ICurrenciesResponse[]> = () =>
	ticketControlApi.get<ICurrenciesResponse[]>('api/Currencies/simple', {}, true);

getCurrencies.queryKey = 'getCurrencies';

const getCurrenciesAndCountries: IServiceMethod<ICurrenciesAndCountriesResponse[]> = () =>
	ticketControlApi.get<ICurrenciesAndCountriesResponse[]>('api/StripeCurrencies', {}, true);

getCurrenciesAndCountries.queryKey = 'getCurrenciesAndCountries';

const getPaid: IServiceMethod<IPaidTicketModel[]> = () =>
	appApi.get<IPaidTicketModel[]>('v2/tournaments/tickets/player', {}, true);

getPaid.queryKey = 'getPaidTickets';

const getFree: IServiceMethod<IFreeTicketModel[]> = () => appApi.get<IFreeTicketModel[]>('tickets/player', {}, true);

getFree.queryKey = 'getFreeTickets';

const getFreeStats: IServiceMethod<ITicketStatsModel[]> = () =>
	appApi.get<ITicketStatsModel[]>('tickets/player/stats', {}, true);

getFreeStats.queryKey = 'getFreeStats';

const getFreeByType: IServiceMethod<IFreeTicketModel[]> = (type) =>
	appApi.get<IFreeTicketModel[]>('tickets/player/type', { params: { type } }, true);

getFreeByType.queryKey = 'getFreeByType';

const getPlayerTonTickets: IServiceMethod<IGetPlayerTonTicketsResponse[], IGetPlayerTonTicketsRequest> = (body) =>
	ticketControlApi.post('api/Tickets/players/tickets/ton', { body }, true);

getPlayerTonTickets.queryKey = 'getPlayerTonTickets';

const getPlayerStarsTicketByPaymentId: IServiceMethod<IGetPlayerStarsTicketsResponse, IGetPlayerStarsTicketsRequest> = (
	body,
) => ticketControlApi.get(`api/Tickets/payment/telegram/${body?.paymentId}/ticket`, {}, true);

getPlayerStarsTicketByPaymentId.queryKey = 'getPlayerStarsTicketByPaymentId';

export const TicketService = {
	create,
	createIntent,
	getCurrencies,
	getCurrenciesAndCountries,
	getFree,
	getFreeByType,
	getFreeStats,
	getPaid,
	getPlayerStarsTicketByPaymentId,
	getPlayerTonTickets,
	getTicketByPayment,
};
